import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import auroraLogo from "../../assets/Aurora Logo.png";

const categories = [
  {
    name: 'Aerial Fancy',
    subtitle: 'Colorful fireworks that light up the sky',
    image:
      'https://images.pexels.com/photos/31196839/pexels-photo-31196839.jpeg',
    route: '/fancy',
  },
  {
    name: 'Chakkras',
    subtitle: 'Bright spinning effects for every celebration',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7d45-3ZiPusEnawpTAfxvjEacYvOfKO2VN166Fguwfw&s=10',
    route: '/chakras',
  },
  {
    name: 'Crackers / Bombs / Bijili',
    subtitle: 'Classic crackers for festive celebrations',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTs9a1Q-IdqqVZmzFgJm_HkpgW8cpMm7DKleiaBx35T-A&s=10',
    route: '/crackers',
  },
  {
    name: 'Flower Pots',
    subtitle: 'Beautiful fountains of sparkling light',
    image:
      'https://images.pexels.com/photos/6054332/pexels-photo-6054332.jpeg',
    route: '/flowerpots',
  },
  {
    name: 'Garland Wala',
    subtitle: 'Traditional celebration favorites',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOUSQs-nw6FzUAuQAYbYoGTGZwaGxt3-Aie5-iYrVwgw&s=10',
    route: '/garland',
  },
  {
    name: 'Fountain',
    subtitle: 'Elegant sparkling fountain effects',
    image:
      'https://images.pexels.com/photos/949592/pexels-photo-949592.jpeg',
    route: '/fountains',
  },
  {
    name: 'Twinklers / Sparklers',
    subtitle: 'Simple, bright moments of celebration',
    image:
      'https://thumbs.dreamstime.com/b/diwlai-festival-celebration-people-tirunelveli-tamilnadu-india-nov-diwali-festival-lights-one-major-256472206.jpg?w=768',
    route: '/sparklers',
  },
  {
    name: 'Rockets',
    subtitle: 'Reach for the sky with colorful rockets',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPjDcl8kEb4gjKSmh1PTa8SyNa5clh73kaRCc5Qa7hEA&s=10',
    route: '/rocket',
  },
  {
    name: 'Gift Boxes',
    subtitle: 'Festive collections for gifting and family',
    image:
      'https://images.pexels.com/photos/4246120/pexels-photo-4246120.jpeg',
    route: '/giftbox',
  },
];

const benefits = [
  {
    icon: '✦',
    title: 'Wide Range',
    text: 'Fireworks for every celebration',
  },
  {
    icon: '◆',
    title: 'Best Prices',
    text: 'Great value for your family',
  },
  {
    icon: '▣',
    title: 'Safe Packaging',
    text: 'Carefully packed with attention',
  },
  {
    icon: '✓',
    title: 'Quality Products',
    text: 'Selected for a joyful experience',
  },
  {
    icon: '⌂',
    title: 'Customer Support',
    text: 'We are here to help',
  },
];

const Home = () => {
  return (
    <main className="vfx-home">

      {/* ================= HERO ================= */}

      <section className="vfx-hero">

        <div className="vfx-hero-glow vfx-hero-glow-one" />
        <div className="vfx-hero-glow vfx-hero-glow-two" />

        <div className="vfx-hero-content">

          <span className="vfx-hero-tag">
            ✦ FESTIVE FIREWORKS COLLECTION ✦
          </span>

          <h1 className="vfx-hero-title">
   Aurora Fire Works
  <span> Ignite the Joy</span>
</h1>

          <p className="vfx-hero-description">
            Discover beautiful fireworks, classic crackers, and festive
            collections for your next celebration.
          </p>

          <div className="vfx-hero-actions">

            {/* <Link to="/fancy" className="vfx-btn vfx-btn-primary">
              SHOP NOW <span>→</span>
            </Link> */}

            <a
  href="#vfx-categories"
  className="vfx-btn vfx-btn-primary"
>
  SHOP NOW <span>→</span>
</a>

            <Link to="/giftbox" className="vfx-btn vfx-btn-outline">
              EXPLORE GIFT BOXES
            </Link>

          </div>

          <div className="vfx-hero-features">

            <div className="vfx-hero-feature">
              <span>✦</span>
              <div>
                <strong>Wide Selection</strong>
                <small>Festive favorites</small>
              </div>
            </div>

            <div className="vfx-hero-feature">
              <span>✓</span>
              <div>
                <strong>Quality Focused</strong>
                <small>Carefully selected</small>
              </div>
            </div>

            <div className="vfx-hero-feature">
              <span>◆</span>
              <div>
                <strong>Secure Shopping</strong>
                <small>Easy online ordering</small>
              </div>
            </div>

          </div>

        </div>

        {/* ================= AURORA LOGO ================= */}

        <div className="vfx-hero-visual">

          <div className="vfx-aurora-hero-decoration vfx-aurora-deco-one">
            ✦
          </div>

          <div className="vfx-aurora-hero-decoration vfx-aurora-deco-two">
            ✧
          </div>

          <div className="vfx-aurora-hero-decoration vfx-aurora-deco-three">
            ✦
          </div>

          <div className="vfx-aurora-logo-stage">

            <div className="vfx-aurora-logo-ring vfx-aurora-ring-outer" />

            <div className="vfx-aurora-logo-ring vfx-aurora-ring-inner" />

            <div className="vfx-aurora-logo-circle">

              <img
                src={auroraLogo}         
                alt="Aurora Fire Works"
                className="vfx-aurora-logo-image"
              />

            </div>

            <div className="vfx-aurora-logo-name">
              <span>AURORA</span>
              <strong>FIRE WORKS</strong>
            </div>

          </div>

        </div>

      </section>

      {/* ================= BENEFITS ================= */}

      <section id="vfx-categories" className="vfx-benefits">

        <div className="vfx-container vfx-benefits-grid">

          {benefits.map((benefit) => (
            <div className="vfx-benefit-item" key={benefit.title}>

              <span className="vfx-benefit-icon">
                {benefit.icon}
              </span>

              <div>
                <h3>{benefit.title}</h3>
                <p>{benefit.text}</p>
              </div>

            </div>
          ))}

        </div>

      </section>

      {/* ================= CATEGORIES ================= */}

      <section className="vfx-categories-section">

        <div className="vfx-container">

          <div className="vfx-section-heading">

            <span className="vfx-section-label">
              EXPLORE OUR COLLECTION
            </span>

            <h2>Shop By Category</h2>

            <p>
              Find the perfect fireworks for every celebration and special
              moment.
            </p>

          </div>

          <div className="vfx-category-grid">

            {categories.map((category) => (

              <Link
                to={category.route}
                className="vfx-category-card"
                key={category.name}
              >

                <div className="vfx-category-image-wrap">

                  <img
                    src={category.image}
                    alt={category.name}
                    className="vfx-category-image"
                  />

                  <div className="vfx-category-overlay" />

                  <span className="vfx-category-badge">
                    EXPLORE
                  </span>

                </div>

                <div className="vfx-category-content">

                  <h3>{category.name}</h3>

                  <p>{category.subtitle}</p>

                  <span className="vfx-category-link">
                    SHOP NOW <span>→</span>
                  </span>

                </div>

              </Link>

            ))}

          </div>

        </div>

      </section>

      {/* ================= PROMO ================= */}

      <section className="vfx-promo-section">

        <div className="vfx-container">

          <div className="vfx-promo-card">

            <div className="vfx-promo-content">

              <span className="vfx-promo-label">
                MAKE IT MEMORABLE
              </span>

              <h2>
                Bring More Joy To Your Celebration
              </h2>

              <p>
                Explore our collection of festive favorites and create
                beautiful memories with family and friends.
              </p>

              <Link to="/fancy" className="vfx-btn vfx-btn-primary">
                SHOP ALL PRODUCTS <span>→</span>
              </Link>

            </div>

            <div className="vfx-promo-visual">

              <div className="vfx-promo-burst vfx-promo-burst-one">
                ✦
              </div>

              <div className="vfx-promo-burst vfx-promo-burst-two">
                ✧
              </div>

              <div className="vfx-promo-burst vfx-promo-burst-three">
                ✦
              </div>

              <div className="vfx-promo-product">

                <div className="vfx-promo-product-box">
                  <span>CELEBRATE</span>
                  <strong>JOY</strong>
                  <small>FESTIVE COLLECTION</small>
                </div>

                <div className="vfx-promo-cone" />

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= SHOPPING INFO ================= */}

      <section className="vfx-info-section">

        <div className="vfx-container vfx-info-grid">

          <div className="vfx-info-card">
            <span className="vfx-info-icon">◆</span>
            <div>
              <h3>Easy Shopping</h3>
              <p>Browse your favorite categories and place your order.</p>
            </div>
          </div>

          <div className="vfx-info-card">
            <span className="vfx-info-icon">▣</span>
            <div>
              <h3>Secure Payment</h3>
              <p>Shop confidently with our secure payment process.</p>
            </div>
          </div>

          <div className="vfx-info-card">
            <span className="vfx-info-icon">✦</span>
            <div>
              <h3>Festive Collections</h3>
              <p>Discover products for every celebration.</p>
            </div>
          </div>

        </div>

      </section>

      {/* ================= FINAL CTA ================= */}

      <section className="vfx-final-cta">

        <div className="vfx-container">

          <div className="vfx-final-cta-content">

            <span className="vfx-final-cta-label">
              YOUR CELEBRATION STARTS HERE
            </span>

            <h2>Make Every Celebration Shine</h2>

            <p>Explore our fireworks collection today.</p>

            <Link to="/fancy" className="vfx-btn vfx-btn-primary">
              SHOP NOW <span>→</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
};

export default Home;